module.exports = __webpack_public_path__ + "img/exhibitor.1ad6ca27.png";